import { render, staticRenderFns } from "./glossary.component.vue?vue&type=template&id=7170c39c&"
import script from "./glossary.component.ts?vue&type=script&lang=ts&"
export * from "./glossary.component.ts?vue&type=script&lang=ts&"
import style0 from "./glossary.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports